const GET_BOT_RESPONSE = (state, botmsg) => {
  state.botmsg = botmsg;
};

const GET_TRANSLATED_TEXT = (state, translation) => {
  state.translation = translation;
};

export default {
  GET_BOT_RESPONSE,
  GET_TRANSLATED_TEXT
};



// WEBPACK FOOTER //
// ./src/store/modules/teachbot/mutations.js